/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
// import GetSheetDone from 'get-sheet-done'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

const ARTICLE_ID = '909551768575'
const SHEETID = '1lIPrLUw4nzen9vceQ6m-kICKykvX_CQKT8hFGiOemII'
const APIKEY =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyDykwbOym-uh9R3CQUG1H1By9FH12LCI3Y'
    : 'AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA'

export function AppComponent() {
  const [ids, setIds] = useState([])
  const [texts, setTexts] = useState({
    title: null,
    lead: null,
    intro: null,
    date: null,
  })

  useEffect(() => {
    // GetSheetDone.labeledCols(SHEETID, 2).then((data) => {
    //   console.log(data)
    //   setTexts({
    //     title: data.data[0].titre,
    //     lead: data.data[0].chapeau,
    //     date: data.data[0].date,
    //   })
    // })

    // GetSheetDone.labeledCols(SHEETID, 1).then((data) => {
    //   console.log(data.data)
    //   const ids = data.data.reduce((a, b) => [...a, b.id], [])
    //   console.log(ids)
    //   setIds(ids)
    // })

    window
      .fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${SHEETID}/values/${'textes'}?alt=json&key=${APIKEY}`
      )
      .then((res) => {
        return res.json().then((json) => {
          console.log(json.values)
          setTexts({
            title: json.values[1][0],
            lead: json.values[1][1],
            intro: json.values[1][2],
            date: json.values[1][3],
          })
        })
      })

    window
      .fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${SHEETID}/values/${'articles'}?alt=json&key=${APIKEY}`
      )
      .then((res) => {
        return res.json().then((json) => {
          console.log(json.values.slice(1, json.values.length))
          const ids = json.values
            .slice(1, json.values.length)
            .reduce((a, b) => [...a, b[0]], [])
          console.log(ids)
          setIds(ids)
        })
      })
  }, [])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very fitted  segment'>
        <div className='ui container'>
          {texts.title ? (
            <>
              <div className='ui header'>
                <h1>{texts.title}</h1>
                <h2>{texts.lead}</h2>
              </div>
              <div className='ui vertical very fitted segment'>
                <div className='ui text container'>
                  <div className='ta metainfo'>
                    <div className='ta author'>Aurélie Toninato</div>
                    <div className='ta updated'>{texts.date}</div>
                  </div>
                  <div className='ta text'>
                    <p>{texts.intro}</p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className='ui header'>
              <div className='ui fluid placeholder'>
                <div className='header'>
                  <div className='medium line' />
                  <div className='short line' />
                </div>
                <div className='paragraph'>
                  <div className='very long line' />
                  <div className='very long line' />
                  <div className='medium line' />
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      <div className='ui container' style={{ marginTop: '2em' }}>
        <ArticleTeasers numberOfCards='three' articleIds={ids} />
      </div>
      <Footer
        hidePortfolioTeaser
        mailTo='aurelie.toninato@tdg.ch'
        articleId={ARTICLE_ID}
        credits={[['Textes', 'Aurélie Toninato']]}
      />
    </div>
  )
}
